import events from "@/bl-events"

const onCategorisation = (categories) => {
  const body = document.querySelector("body")
  Object.keys(categories).forEach((category) => {
    const className = `${category}-${categories[category]}`
    if (!body.classList.contains(className)) {
      body.classList.add(className)
    }
  })
}

events.on("abtest:ready", onCategorisation)
events.on("blinkist:authenticate_data_ready", (config) => onCategorisation(config.test_categories))
